import React, { useState } from "react";
import classNames from "classnames";

import Collapse from "react-collapse";

import Select from "../Select";

import "./_style.scss";

const AdvancedFilters = ({
  onOwnerTypeSelect,
  onOwnerTypeSelectAll,
  selectedOwnerType,
  onPercentageRaisedSelect,
  onPercentageRaisedSelectAll,
  selectedPercentageRaised,
}) => {
  const [isOpened, setIsOpened] = useState(false);

  const toggleIsOpen = () => {
    setIsOpened(!isOpened);
  };

  return (
    <div className="advancedFilters">
      <div className="advancedFilters__toggler">
        <span
          className="advancedFilters__togglerText"
          onClick={toggleIsOpen}
        >
          <span>Refine</span>
          <span className="advancedFilters__togglerDivider" />
        </span>
      </div>
      <Collapse
        isOpened={isOpened}
        springConfig={{ stiffness: 210, damping: 20 }}
      >
        <section className="advancedFilters__content">
          <h1 className="advancedFilters__mainHeading">Filter by</h1>
          <div
            className={classNames("advancedFilters__filterGroups", {
              "--centered": true,
            })}
          >
            <div className="advancedFilters__filterGroup">
              <h2 className="advancedFilters__subHeading">Campaigner Type</h2>
              <Select
                className="campaign-type"
                name="campaign-type"
                items={[
                  { label: "Individual only", value: "Individual" },
                  { label: "Organisations only", value: "Organisation" },
                ]}
                onItemSelect={onOwnerTypeSelect}
                onSelectAll={onOwnerTypeSelectAll}
                selectedItems={selectedOwnerType}
              />
            </div>
            <div className="advancedFilters__filterGroup">
              <h2 className="advancedFilters__subHeading">
                Percentage Raised
              </h2>
              <Select
                className="percentage-raised"
                name="percentage-raised"
                items={[
                  { label: "> 100%", value: "1.25" },
                  { label: "75 - 100%", value: "1" },
                  { label: "50 - 75%", value: "0.75" },
                  { label: "25 - 50%", value: "0.50" },
                  { label: "0 - 25%", value: "0.25" },
                ]}
                onItemSelect={onPercentageRaisedSelect}
                onSelectAll={onPercentageRaisedSelectAll}
                selectedItems={selectedPercentageRaised}
              />
            </div>
          </div>
        </section>
      </Collapse>
    </div>
  );
};

export default AdvancedFilters;
